import React, { useState } from "react";
import { CheckCircle, XCircle, AlertTriangle, Info, X } from "lucide-react";
import "./Notifications.css";

const NotificationItem = ({ notification, onRemove }) => {
  const [isExiting, setIsExiting] = useState(false);

  const handleRemove = () => {
    setIsExiting(true);
    setTimeout(() => {
      onRemove(notification.id);
    }, 300); // Match animation duration
  };

  const getIcon = () => {
    switch (notification.type) {
      case "success":
        return <CheckCircle size={20} />;
      case "error":
        return <XCircle size={20} />;
      case "warning":
        return <AlertTriangle size={20} />;
      case "info":
        return <Info size={20} />;
      default:
        return <Info size={20} />;
    }
  };

  return (
    <div
      className={`notification-item notification-${notification.type} ${isExiting ? "notification-exit" : ""}`}
    >
      <div className="notification-icon">{getIcon()}</div>

      <div className="notification-content">
        <p className="notification-message">{notification.message}</p>
        {notification.details && (
          <p className="notification-details">{notification.details}</p>
        )}

        {notification.action && (
          <button
            className="notification-action-btn"
            onClick={() => {
              notification.action.onClick();
              handleRemove();
            }}
          >
            {notification.action.label}
          </button>
        )}
      </div>

      <button
        className="notification-close-btn"
        onClick={handleRemove}
        aria-label="Close notification"
      >
        <X size={18} />
      </button>
    </div>
  );
};

export default NotificationItem;
